import { render } from "./Tabs.vue?vue&type=template&id=53b2aaba&scoped=true"
import script from "./Tabs.vue?vue&type=script&lang=js"
export * from "./Tabs.vue?vue&type=script&lang=js"

import "./Tabs.vue?vue&type=style&index=0&id=53b2aaba&scoped=true&lang=css"

import exportComponent from "/root/.jenkins/workspace/prod-mdcms-admin/md-cms/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53b2aaba"]])

export default __exports__